import React, { useContext, useEffect, useState } from "react";
import { userContext } from "../../Contexts/userContext";
import TransactionResult from "../../Template/Home/Transactions/TransactionResult";
import { useLocation } from "react-router-dom";

function TransactionResultPage() {
  return <TransactionResult />;
}

export default TransactionResultPage;
